'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

exports.default = getRange;

var _get2 = require('lodash/get');

var _get3 = _interopRequireDefault(_get2);

var _shouldFetchRange = require('../list/should-fetch-range');

var _shouldFetchRange2 = _interopRequireDefault(_shouldFetchRange);

var _transformable2 = require('./_transformable');

var _transformable3 = _interopRequireDefault(_transformable2);

var _range = require('../list/range');

var _range2 = _interopRequireDefault(_range);

var _getRoot = require('./get-root');

var _getRoot2 = _interopRequireDefault(_getRoot);

var _compact2 = require('./_compact');

var _compact3 = _interopRequireDefault(_compact2);

var _selectors3 = require('./_selectors');

var _selectors4 = _interopRequireDefault(_selectors3);

var _stateHelper = require('./_state-helper');

var _throttledDispatch = require('./throttled-dispatch');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var rangeDefaults = {
    namespace: null,
    listName: 'all',
    fetch: 'fetchRange',
    storeName: '$store',
    condition: function condition() {
        return true;
    }
};

function getRange(rangeSelector, listName) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};

    options = (0, _extends3.default)({}, rangeDefaults, options);

    var _options = options,
        namespace = _options.namespace,
        storeName = _options.storeName;
    var _options2 = options,
        fetch = _options2.fetch,
        condition = _options2.condition;

    var _selectors2 = (0, _selectors4.default)(rangeSelector, (0, _extends3.default)({}, options, { listName: listName })),
        getSelection = _selectors2.getSelection,
        getListName = _selectors2.getListName,
        getParams = _selectors2.getParams,
        getHash = _selectors2.getHash;

    if (namespace && typeof fetch === 'string') fetch = namespace + '/' + fetch;

    return (0, _transformable3.default)(function () {
        var opts = getParams(this);
        var listName = getListName(this, opts);

        var _ref = getSelection(this, opts) || {},
            _ref$start = _ref.start,
            start = _ref$start === undefined ? 0 : _ref$start,
            _ref$end = _ref.end,
            end = _ref$end === undefined ? 9 : _ref$end;

        var store = (0, _get3.default)(this, storeName);
        var hash = getHash(opts);
        var allowFetch = condition(this, opts);
        var dispatch = (0, _throttledDispatch.wrapDispatch)(store.dispatch);

        (0, _stateHelper.updateListHash)(store, namespace, listName, hash);

        var root = (0, _getRoot2.default)(store.state, namespace);
        if (allowFetch && (0, _shouldFetchRange2.default)(root, listName, start, end)) dispatch(fetch, (0, _extends3.default)({ listName: listName, start: start, end: end }, opts));

        var entries = (0, _range2.default)(root, listName, start, end, opts);
        return (0, _compact3.default)(entries);
    });
}